/**
 * Hook `useChangePassword` — TH-55255 / área do usuário.
 *
 * Chama POST /api/auth/change-password. O backend:
 *   - Valida a senha atual antes de aceitar a nova.
 *   - Revoga todos os refresh_tokens ativos (logout forçado em outros
 *     dispositivos).
 *   - Retorna 204 No Content em sucesso.
 *
 * Força senha mínima de 12 chars conforme LGPD Cl. 8.1.c (bcrypt cost 12
 * pressupõe senha forte — validação idêntica feita também no backend via
 * `_validate_password_strength`).
 */

import { useMutation } from "@tanstack/react-query";

export interface ChangePasswordPayload {
  current_password: string;
  new_password: string;
}

async function changePassword(payload: ChangePasswordPayload): Promise<void> {
  const res = await fetch("/api/auth/change-password", {
    method: "POST",
    credentials: "include",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { detail?: string };
    throw new Error(body.detail ?? `HTTP ${res.status}`);
  }
}

export function useChangePassword() {
  return useMutation({
    mutationFn: changePassword,
  });
}
